import { handleAxiosErrorMessage } from '@common/utils/axios-error-message';
import { Alert, AlertTitle } from '@mui/material';
import type { AxiosError } from 'axios';

function RequestErrorBanner({ error }: { error: AxiosError }) {
  return (
    <Alert severity="warning" variant="outlined">
      <AlertTitle>Error</AlertTitle>
      {handleAxiosErrorMessage(error)}
    </Alert>
  );
}

export default RequestErrorBanner;
